import { useRef, useState } from "react";
import { Box, Button, IconButton, Modal } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { COLORS } from "../../utils/colors";
import { ImageModal } from "./image-modal";

const HorizontalScrollGallery = ({ images = [], width = 300 }) => {
  const [showModal, setShowModal] = useState(false);
  const [photoUrl, setPhotoUrl] = useState(false);
  const scrollContainerRef = useRef(null);

  const handleScroll = (direction) => {
    if (scrollContainerRef.current) {
      const scrollAmount = width; // Adjust based on image width + margin
      scrollContainerRef.current.scrollBy({
        left: direction * scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleOpenModal = (url) => () => {
    setShowModal(true);
    setPhotoUrl(url);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setPhotoUrl("");
  };

  return (
    <Box sx={{ position: "relative", width: "100%", margin: "auto" }}>
      <IconButton
        sx={{
          position: "absolute",
          top: "50%",
          left: 0,
          zIndex: 1,
          transform: "translateY(-50%)",
          backgroundColor: COLORS.SURFACE_1, // Primary blue
          color: "#fff",
          padding: 1,
          borderRadius: "50%",
          boxShadow: 2,
          "&:hover": {
            opacity: 0.9, // Darker blue on hover
          },
          "&:focus-visible": {
            outline: "3px solid #ff9800", // Orange outline on focus
          },
        }}
        onClick={() => handleScroll(-1)}
      >
        <ArrowBackIos />
      </IconButton>

      <Box
        ref={scrollContainerRef}
        sx={{
          cursor: "pointer",
          display: "flex",
          overflowX: "auto",
          scrollSnapType: "x mandatory",
          gap: 2,
          paddingBottom: 4,
        }}
      >
        {images.map((src, index) => (
          <Box
            key={index}
            sx={{
              flexShrink: 0,
              width: 300,
              height: 200,
              scrollSnapAlign: "center",
              borderRadius: 2,
              boxShadow: 3,
              "& img": {
                width: "100%",
                height: "100%",
                borderRadius: "inherit",
                objectFit: "cover",
              },
            }}
          >
            <img
              onClick={handleOpenModal(src)}
              src={src}
              alt={`Image ${index + 1}`}
            />
          </Box>
        ))}
      </Box>

      <IconButton
        sx={{
          position: "absolute",
          top: "50%",
          right: 0,
          zIndex: 1,
          transform: "translateY(-50%)",
          backgroundColor: COLORS.SURFACE_1,
          color: "#fff",
          padding: 1,
          borderRadius: "50%",
          boxShadow: 2,
          "&:hover": {
            opacity: 0.9,
          },
          "&:focus-visible": {
            outline: "3px solid #ff9800",
          },
        }}
        onClick={() => handleScroll(1)}
      >
        <ArrowForwardIos />
      </IconButton>
      <ImageModal open={showModal} onClose={handleCloseModal} url={photoUrl} />
    </Box>
  );
};

export default HorizontalScrollGallery;
